<template>
  <div class="seedling-raisingfactory">
    <MyNav />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
    MyNav: () => import("@/components/MyNav.vue"),
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      farmInfo: (state) => state.user.farmInfo,
    }),
  },
  created() {},
};
</script>

<style lang="less" scoped>
.seedling-raisingfactory {
  width: 100%;
  min-height: 100vh;
  padding-top: 62px;
  background-color: #071a2c;
  padding: 72px 0 0;
  color: #fff;
  overflow-x: hidden;
}
</style>
